// extracted by mini-css-extract-plugin
export default {"confirmSection":"SystemErrorMessage_confirmSection__i++fc","errorIcon":"SystemErrorMessage_errorIcon__hm8bB","confirmBold":"SystemErrorMessage_confirmBold__PpOnT"};